// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9363 ? "cff4c5fa" : chunkId) + "." + {"2516":"13af662dc249c46c","9363":"d0d586bad2f628b4"}[chunkId] + ".js";
};